import { request } from '@umijs/max';
import { RequestType } from '@/interface';
import { CommunityInfoType } from '@/pages/Home/interface';

/**
 * @desc 查询微信账户下的小区
 * @param openId
 */
export const queryWechatBindCommunity = async (openId: string) => {
  return request<Promise<RequestType<Array<CommunityInfoType>>>>(
    `/api/property/api/senke/Wxchat/binding/getCommunitys/${openId}`,
  );
};
